import type { FC } from 'react'
import { SlugPathItem } from 'types/slugPath'
import CategoryPathHeaderRedesign from '@/components/molecules/categoryPathHeaderRedesign'

type ProductListingPathHeaderRedesignProps = {
  title: string
  paths: SlugPathItem[]
}

const ProductListingPathHeaderRedesign: FC<ProductListingPathHeaderRedesignProps> =
  ({ title, paths }) => {
    return (
      <CategoryPathHeaderRedesign
        mb={title ? '4px' : '58px'}
        display={'flex'}
        paths={paths}
      />
    )
  }

export default ProductListingPathHeaderRedesign
